var app = angular.module('leonardo');

var WorkOrderForm = function (
  $scope,
  $rootScope,
  $state,
  $window,
  $q,
  $filter,
  $timeout,
  workOrderOjb,
  WorkOrderService,
  AccountUserService,
  ngDialog,
  FormErrorsService,
  AccountService,
  AuthDataService,
  PermissionService,
  PropertyService,
  UnitService,
  AttachmentService,
  TemplateService,
  FilterService,
  NotificationService,
  WorkOrderCVService,
  AnalyticsService
) {
  $scope.action = $state.current.action;
  $scope.workOrder = workOrderOjb;
  $scope.permissionService = PermissionService;
  $scope.authDataService = AuthDataService;
  $scope.templateService = TemplateService;
  $scope.tabsCollapsed = [];
  $scope.account = null;
  if (FilterService.currentProperty) {
    $scope.account = FilterService.currentProperty.account;
  }
  else {
    $scope.account = (AccountUserService.currentAccountUser ? AccountUserService.currentAccountUser.account : null);
  }
  $scope.accountUserService = AccountUserService;
  $scope.workOrderCVService = WorkOrderCVService;
  $scope.unitService = UnitService;
  $scope.property_name = '';
  $scope.pms_plattform_id='';
  $scope.buildingPattern = {
    pattern: new RegExp('^[a-zA-Z0-9-]+$'),
    text: 'Buildings can be alphanumeric and might even include a "-"'
  };

  $scope.static_fields_filter = {
    unit: {
      account: $scope.account,
      property: null,
      with_building: true,
      fetch_resident: true
    }
  };
  if ($scope.workOrder) {
    $scope.static_fields_filter.unit.property = $scope.workOrder.property;
    $scope.static_fields_filter.unit.account = $scope.workOrder.account;
  }
  else {
    $scope.static_fields_filter.unit.property = FilterService.currentProperty ? FilterService.currentProperty.id : null;
  }

  if ($scope.action === 'edit') {
    $scope.data = angular.copy($scope.workOrder);
    $scope.data.technician_notes =
      !isNull($scope.data.technician_notes) && $scope.data.technician_notes !== 'null' ? $scope.data.technician_notes : '';
    if ($scope.workOrder.account_users_assigned) {
      $scope.data.account_users_assigned = [];
      angular.forEach($scope.workOrder.account_users_assigned, function (account_user) {
        $scope.data.account_users_assigned.push(account_user.id);
      });
    }
    $scope.account = $scope.data.account;
    if ($scope.workOrder.attachments && $scope.workOrder.attachments.length > 0) {
      var ids = $scope.workOrder.attachments.map(function (obj) {
        return obj.id ? obj.id : obj;
      });
      var filters = {
        disable_pagination: true,
        id: ids.join(',')
      };
      AttachmentService.getlist(filters).then(function (data) {
        $scope.data.attachments = data.results ? data.results : data;
      });
    }
  }
  else {
    $scope.data = {
      account: $scope.account,
      requester_name: '',
      service_request_date: moment().format('YYYY-MM-DD'),
      attachments: [],
      notes: [],
      property: FilterService.currentProperty ? FilterService.currentProperty.id : null,
      pms_extra_fields: {}
    };
  }

$scope.getCustomConfigs = function() {
    var accountId = $scope.account;
    WorkOrderService.getCustomConfigs(accountId).then(function(data) {
        $timeout(function() {
            $scope.customConfigs = data.results || data;
        });
    });
};


  if ($scope.data.property) {
    PropertyService.get($scope.data.property).then(function (property) {
      $scope.pms_plattform_id=property.pms_platform.id
      $scope.property_name = property.name;
  if($scope.pms_plattform_id===2){
    $q.when($scope.account).then(function () {
    $scope.getCustomConfigs();
});
  }
    });
  }
  else {
    $scope.property_name = FilterService.currentProperty.name;
  }

  $scope.getValidOptions = function (field) {
    let result = null;
    if (field.valid_transitions) {
      const value = $scope.workOrder ? $scope.workOrder.pms_extra_fields[field.name.replace(/ /g,"_")] : null;
      const value_label = angular.isArray(value) ? value.map((op) => op?.name || op).join(',') : value?.name || value;
      result = field.valid_transitions[value_label];
    }
    return result;
  };

  $scope.initExtraFields = function () {
    if ($scope.platformFields) {
      var fields = [].concat($scope.platformFields.override_fields, $scope.platformFields.fields).filter(Boolean);
      angular.forEach(fields, function (field) {
        if (field.name === 'due_date') {
          $scope.data.due_date = $scope.getValidation(field.name, 'start_date');
        }
        if ($scope.platformFields.pms_platform === 'entrata' && field.name === 'status') {
          var filtr = $scope.getFilters(field);
          var paramObject = {
            essential: true,
            noerror: true,
            parents: filtr.parents,
            property: filtr.property,
            type: filtr.type,
          };
          try {
            WorkOrderCVService.getlist(paramObject).then(resp => {
              var jsonObject = resp && resp.find((x) => x.name === 'Open');
              if(jsonObject){
                $scope.data.pms_extra_fields[field.name.replace(/ /g, "_")] = [{
                  "id": jsonObject.id,
                  "name": jsonObject.name
                }];
              }
            });
          } catch (error) {
            console.error("Error in API call:", error);
          }
        }
        field.validOptions = $scope.getValidOptions(field);
      });
      $scope.initExtraFieldsFilters();
    }
  };

  $q.when($scope.account).then(function () {
    $scope.getPlatformFields();
  });

  $scope.getPlatformFields = function () {
    WorkOrderService.getPlatformFields({ property: $scope.data.property }).then(function (data) {
      $scope.platformFields = data.results || data;
      $scope.initExtraFields();
    });
  };

  $scope.changeCustomValue = function (field) {
    if ($scope.platformFields && $scope.platformFields.fields) {
      angular.forEach($scope.platformFields.fields, function (child) {
        if (child.parent_types && child.parent_types.length > 0) {
          if (field.type && child.parent_types.includes(field.type)) {
            $scope.data.pms_extra_fields[child.name.replace(/ /g,"_")] = null;
          }
        }
        if (isEmpty($scope.data.pms_extra_fields[field.name.replace(/ /g, "_")])) {
          $scope.data.pms_extra_fields[field.name.replace(/ /g, "_")] = null;
        }
      });
      if (field.name == 'unit' && $scope.data.unit && $scope.data.unit.length > 0 && $scope.data.unit[0]['id']) {
        $scope.data.requester_name = $scope.data.unit[0]['resident_name'] || $filter('username')(AccountUserService.currentAccountUser.user);
        $scope.data.requester_phone_number = $scope.data.unit[0]['resident_phone'];
        $scope.data.requester_email = $scope.data.unit[0]['resident_email'];
        if($scope.platformFields.pms_platform === 'entrata'){
              $scope.data.tenant_code = $scope.data.unit[0]['resident_external_id'];
        }
      }
    }
  };

  $scope.getParents = function (field) {
    var result = [];
    if (field.parent_types && field.parent_types.length > 0) {
      if ($scope.platformFields && $scope.platformFields.fields) {
        angular.forEach($scope.platformFields.fields, function (parent) {
          if (parent.type && field.parent_types.includes(parent.type)) {
            let value = $scope.data.pms_extra_fields[parent.name.replace(/ /g,"_")];
            if (!isNull(value)) {
              result.push(angular.isArray(value) ? value.map((op) => op.id || op).join(',') : value.id || value);
            }
          }
        });
      }
    }
    return result ? result.join(',') : '';
  };

  $scope.getValidation = function (field_name, validation_id) {
    var validation = null;
    if ($scope.platformFields) {
      var fields = [].concat($scope.platformFields.override_fields, $scope.platformFields.fields).filter(Boolean);
      angular.forEach(fields, function (field) {
        if (field.name === field_name) {
          if (['date_field', 'datetime_field'].includes(field.field_type) && field[validation_id]) {
            switch (field[validation_id]) {
              case 'yesterday':
                validation = moment().subtract(1, 'day').format('YYYY-MM-DD');
                break;
              case 'today':
                validation = moment().format('YYYY-MM-DD');
                break;
              case 'now':
                validation = moment().format('YYYY-MM-DD HH:mm');
                break;
              case 'tomorrow':
                validation = moment().add(1, 'day').format('YYYY-MM-DD');
                break;
              default:
                validation = moment(field[validation_id]).format('YYYY-MM-DD');
                break;
            }
          } else {
            validation = field[validation_id];
          }
        }
      });
    }
    return validation;
  };

  $scope.getExtraField = function (field) {
    let result = field;
    if ($scope.platformFields) {
      var fields = [].concat($scope.platformFields.override_fields, $scope.platformFields.fields).filter(Boolean);
      angular.forEach(fields, function (element) {
        if (element.name === field.name) {
          result = element;
        }
      });
    }
    return result;
  };

  $scope.getFilters = function (field) {
    let filtersObj = {
      property: $scope.data.property,
      type: field.type
    };
    filtersObj.parents = $scope.getParents(field);
    if (field.filter_fields) {
      angular.forEach(field.filter_fields, function (filter) {
        const value = $scope.data[filter.replace(/ /g,"_")] || $scope.data.pms_extra_fields[filter.replace(/ /g,"_")];
        filtersObj[filter] = angular.isArray(value) ? value.map((op) => op?.id || op).join(',') : value?.id || value;
      });
    }
    return filtersObj;
  };

  $scope.getOverrideFilters = function (field) {
    var override_filters = angular.copy($scope.static_fields_filter[field.name.replace(/ /g,"_")]) || {};
    if (field.filter_fields) {
      angular.forEach(field.filter_fields, function (filter) {
        if ($scope.data.pms_extra_fields[filter.replace(/ /g,"_")]) {
          let filter_data = $scope.data.pms_extra_fields[filter.replace(/ /g,"_")];
          override_filters[filter] = angular.isArray(filter_data) ? filter_data.map((op) => op?.name || op).join(',') : filter_data?.name || filter_data;
        }
      });
    }
    return override_filters;
  };

  $scope.initExtraFieldsFilters = function () {
    if ($scope.platformFields && $scope.platformFields.fields) {
      angular.forEach($scope.platformFields.fields, function (field) {
        field.filters = $scope.getFilters(field);
        if(field.filters && (field.filters.category || field.filters.unit )){
          delete field.filters.unit;
          delete field.filters.category;
        }
      });
    }
    if ($scope.platformFields && $scope.platformFields.override_fields) {
      angular.forEach($scope.platformFields.override_fields, function (field) {
        $scope.static_fields_filter[field.name.replace(/ /g,"_")] = $scope.getOverrideFilters(field);
      });
    }
    $scope.setCheckboxes();
  };

  $scope.setCheckboxes = function () {
    angular.forEach($scope.platformFields.fields, function (field) {
      if (field.field_type === 'boolean_field' && isNull($scope.data.pms_extra_fields[field.name.replace(/ /g,"_")])) {
        $scope.data.pms_extra_fields[field.name.replace(/ /g,"_")] = false;
      }
    });

    angular.forEach($scope.platformFields.override_fields, function (field) {
      if (field.name === 'has_permission_to_enter' && isNull($scope.data['has_permission_to_enter'])) {
        $scope.data['has_permission_to_enter'] = false;
      }
    });
  };

  $scope.isDisabledField = function (field) {
    let fieldElement = $scope.getExtraField(field);
    let keysEnabled = $scope.action === 'edit' ? ['all', 'update'] : ['all', 'create'];
    let disabled = fieldElement.show_on ? !keysEnabled.includes(fieldElement.show_on) : false;
    if (fieldElement.parent_types && field.parent_types.length > 0 && !disabled) {
      if ($scope.platformFields && $scope.platformFields.fields) {
        angular.forEach($scope.platformFields.fields, function (parent) {
          if (parent.type && fieldElement.parent_types.includes(parent.type)) {
            disabled = isEmpty($scope.data.pms_extra_fields[parent.name.replace(/ /g, "_")]);
          }
        });
      }
    }
    if ($scope.platformFields) {
      var fields = [].concat($scope.platformFields.override_fields, $scope.platformFields.fields).filter(Boolean);
      angular.forEach(fields, function (element) {
        if (element.choices_rules) {
          let rules = element.choices_rules.filter((c) => (c.show_on_cascade ? c.show_on_cascade.includes(field.name) : false));
          let disabled_rules = element.choices_rules.filter((c) => (c.disable_on_cascade ? c.disable_on_cascade.includes(field.name) : false));
          if (!isEmpty(rules)) {
            angular.forEach(rules, function (rule) {
              let option = $scope.data[element.name.replace(/ /g, "_")] || $scope.data.pms_extra_fields[element.name.replace(/ /g, "_")];
              if (!isEmpty(option)) {
                let option_id = angular.isArray(option) ? option.map((op) => op.id || op).join(',') : option.id || option;
                let option_label = angular.isArray(option) ? option.map((op) => op.name).join(',') : option.name;
                option_label = typeof option == "boolean" ? option.toString() : option_label;
                if (rule.label) {
                  disabled = (rule.label === option_label) ? false : disabled;
                } else {
                  disabled = (rule.id.toString() === option_id.toString()) ? false : disabled;
                }
              }
            });
          }
          if (!isEmpty(disabled_rules)) {
            angular.forEach(disabled_rules, function (disabled_rule) {
              let option = $scope.data[element.name.replace(/ /g, "_")] || $scope.data.pms_extra_fields[element.name.replace(/ /g, "_")];
              if (!isEmpty(option)) {
                if (disabled_rule.id === '*') {
                  disabled = true;
                } else {
                  let option_id = angular.isArray(option) ? option.map((op) => op.id || op).join(',') : option.id || option;
                  let option_label = angular.isArray(option) ? option.map((op) => op.name).join(',') : option.name;
                  option_label = typeof option == "boolean" ? option.toString() : option_label;
                  if (disabled_rule.label) {
                    disabled = (disabled_rule.label === option_label) || disabled;
                  } else {
                    disabled = (disabled_rule.id.toString() === option_id.toString()) || disabled;
                  }
                }
              }
            });
          }
        }
      });
    }

    if (disabled) {
      $scope.data[field.name.replace(/ /g, "_")] = null;
        $scope.data.pms_extra_fields[field.name.replace(/ /g, "_")] = null;
    }
    return disabled;
  };

  $scope.isRequiredField = function (field) {
    if ($scope.isDisabledField(field)) {
      return false;
    }
    var required = false;
    if ($scope.platformFields) {
      var fields = [].concat($scope.platformFields.override_fields, $scope.platformFields.fields).filter(Boolean);
      angular.forEach(fields, function (element) {
        if (element.name === field.name && element.required) {
          required = element.required;
        }
        if (element.choices_rules) {
          let rules = element.choices_rules.filter((c) => (c.required_on_cascade ? c.required_on_cascade.includes(field.name) : false));
          if (!isEmpty(rules)) {
            angular.forEach(rules, function (rule) {
              let option = $scope.data[element.name.replace(/ /g,"_")] || $scope.data.pms_extra_fields[element.name.replace(/ /g,"_")];
              if (!isEmpty(option)) {
                let option_id = angular.isArray(option) ? option.map((op) => op.id || op).join(',') : option.id || option;
                let option_label = angular.isArray(option) ? option.map((op) => op.name).join(',') : option.name;
                if (rule.label) {
                  required = (rule.label === option_label) || required;
                }
                else {
                  required = (rule.id.toString() === option_id.toString()) || required;
                }
              }
            });
          }
        }
      });

      if ($scope.platformFields.pms_platform === 'entrata' && (field.name === 'access notes')) {
        if ($scope.data.unit && $scope.data.unit.length > 0 && $scope.data.unit[0]['id']) {
          required = !$scope.data.has_permission_to_enter;
        } else {
          required = false;
        }
      }
    }

    if ($scope.customConfigs) {      
    angular.forEach($scope.customConfigs, function (config) {
      if (config.mapped_field === field.name) {
        if (config.is_active && !config.to_complete) {
          required = true;
        } else if (config.is_active && config.to_complete && $scope.action === 'edit' && $scope.workOrder) {
          required = true;
        } else {
          required = false;
        }
      }
    });
  }
    return required;
  };

  $scope.showWorkOrderDetail = function (work_order) {
    AnalyticsService.track('Task opened', {
      context: 'work orders',
      destination: 'detail',
      entry_method: 'click',
      ...AnalyticsService.getTaskGroupProperties(work_order)});
    work_order.getTriggerData().then(function (result) {
      ngDialog.open({
        template: 'views/templates/dialog/work-order/detail.html',
        controller: 'WorkOrderDetailsDialog',
        data: {
          work_order: result
        }
      });
    });
  };

  $scope.toggleTab = function (tab) {
    if ($scope.tabHidden(tab)) {
      $scope.tabsCollapsed.splice($scope.tabsCollapsed.indexOf(tab), 1);
    } else {
      $scope.tabsCollapsed.push(tab);
    }
  };

  $scope.tabHidden = function (tab) {
    return $scope.tabsCollapsed.includes(tab);
  };

  $scope.getNameAccount = function (account) {
    var array_account = [];
    if (account) {
      array_account = angular.isArray(account) ? account : account.split(',');
    }
    var labels = [];
    angular.forEach(array_account, function (account_id) {
      if (AuthDataService.authData.account) {
        angular.forEach(AuthDataService.authData.account.managed_to_me, function (managed) {
          if (managed.id == account_id) {
            labels.push(managed.name);
          }
        });
      }
    });
    return labels.join(',');
  };

  $scope.checkAttachments = function () {
    var error = false;
    const permissionUploadYardi = PermissionService.permissionAvailableAccount('permission_upload_work_order');
    const propertyYardiID = FilterService.currentProperty ? !isNull(FilterService.currentProperty.pms_external_id) : false;

    if (!permissionUploadYardi || !propertyYardiID) {
      return;
    }

    if ($scope.data.attachments) {
      angular.forEach($scope.data.attachments, function (attachment) {
        let name;
        if (attachment.file && attachment.file.name) {
          name = attachment.file.name;
        }
        else {
          name = attachment.file ? attachment.file : attachment.name;
        }
        const array_name = name.split('.');
        const extension = array_name.length > 1 ? array_name[array_name.length - 1] : null;
        if (extension && !AttachmentService.validYardiFormats.includes(extension)) {
          error = true;
        }
      });
    }

    if (error && FilterService.currentProperty.pms_platform?.id === WorkOrderService.TYPE_YARDI) {
      NotificationService.error(
        'Warning! Yardi only supports the following file types: .jpg, .jpeg, .pdf <br><br> Any other attachment file type will not be synced'
      );
    }
  };

  $scope.removeAttachment = function (index) {
    $scope.data.attachments.splice(index, 1);
    $scope.checkAttachments();
  };

  $scope.showAttachment = function (index) {
    if ($scope.data.attachments[index].document_file) {
      // Use signed_view_url for secure inline viewing
      $window.open($scope.data.attachments[index].document_file.signed_view_url || $scope.data.attachments[index].document_file.secure_share_url);
    } else if ($scope.data.attachments[index].link) {
      $window.open($scope.data.attachments[index].link);
    } else {
      if (angular.isObject($scope.data.attachments[index].file)) {
        var reader = new FileReader();
        reader.addEventListener(
          'load',
          function () {
            ngDialog.open({
              template: 'views/templates/dialog/show-image.html',
              className: 'ngdialog-theme-default ngdialog-attachments-view',
              data: {
                name: $scope.data.attachments[index].name,
                src: reader.result
              }
            });
          },
          false
        );
        reader.readAsDataURL($scope.data.attachments[index].file);
      } else {
        // Use signed_view_url for secure inline viewing
        $window.open($scope.data.attachments[index].signed_view_url ?? $scope.data.attachments[index].secure_share_url ?? $scope.data.attachments[index].file);
      }
    }
  };

  $scope.showAttachDialog = function () {
    ngDialog
      .openConfirm({
        template: 'views/templates/dialog/attachment/upload.html',
        controller: 'AttachmentUploadDialog',
        data: {
          task: $scope.data,
          mode: 'upload_note',
          showManagement: true,
          account: $scope.data.account
        }
      })
      .then(function (attachments) {
        $scope.data.attachments = [];
        angular.forEach(attachments, function (attachment) {
          $scope.data.attachments.push(attachment);
        });
        $scope.checkAttachments();
      }, function () {
        return;
      });
  };

  $scope.getData = function () {
    var data = angular.copy($scope.data);
    var defer = $q.defer();
    var promises = [];
    if ($scope.data.account_users_assigned) {
      data.account_users_assigned = angular.isArray($scope.data.account_users_assigned)
        ? $scope.data.account_users_assigned
        : $scope.data.account_users_assigned.split(',');
    } else {
      data.account_users_assigned = [];
    }
    if (isNull(data.unit)) {
      delete data['unit'];
    }
    else {
      data.unit = (typeof (data.unit) == 'number') ? data.unit : data.unit[0]['id'];
    }
    if (isNull(data.requester_name)) {
      data.requester_name = $filter('username')(AccountUserService.currentAccountUser.user);
    }
    angular.forEach(Object.keys($scope.data.pms_extra_fields), function (key) {
      const value = $scope.data.pms_extra_fields[key.replace(/ /g,"_")];
      const value_id = angular.isArray(value) ? value.map((op) => op?.id || op).join(',') : value?.id || value;
      data.pms_extra_fields[key.replace(/ /g,"_")] = value_id;
    });
    if ($scope.data.attachments) {
      data.attachments = [];
      angular.forEach($scope.data.attachments, function (attachment) {
        if (attachment.id) {
          data.attachments.push(attachment.id);
        } else {
          if (attachment.document_folder || attachment.document_file) {
            promises.push(
              AttachmentService.linkTo(attachment).then(function (response) {
                data.attachments.push(response.data.id);
              })
            );
          } else if (attachment.link) {
            promises.push(
              AttachmentService.post(attachment.name, null, attachment.link, attachment.available_for_account).then(function (response) {
                data.attachments.push(response.data.id);
              })
            );
          } else {
            promises.push(
              AttachmentService.post(attachment.name, attachment.file, null, attachment.available_for_account).then(function (response) {
                data.attachments.push(response.data.id);
              })
            );
          }
        }
      });
    }

    $q.all(promises).then(function () {
      defer.resolve(data);
    });

    return defer.promise;
  };

  $scope.createWorkOrderObjectForTracking = async function (data, unitDetails) {
    const portfolioId = FilterService.currentPortfolio?.id;
    let priorityName = null;
    try {
      if (data.pms_extra_fields && data.pms_extra_fields.priority) {
        const priorityObj = await WorkOrderCVService.get(data.pms_extra_fields.priority);
        priorityName = priorityObj && priorityObj.name ? priorityObj.name : data.pms_extra_fields.priority;
      }
    } catch (e) {
      priorityName = data.pms_extra_fields?.priority || null;
    }
    const analyticsWorkOrder = {
      brief_description: data.brief_description,
      property: data.property,
      portfolio: unitDetails?.portfolio || portfolioId,
      unit_name: (unitDetails?.building ? unitDetails.building + ' - ' : '') + (unitDetails?.number || null),
      priority: priorityName,
      account_users_assigned:data.account_users_assigned,
      unit_id: data.unit
    };
    return analyticsWorkOrder;
  };

  $scope.submit = function () {
  $scope.Form.$setSubmitted();
  if ($scope.Form.$invalid) {
    FormErrorsService.goToError();
    return;
  }
  $scope.getData().then(function (data) {
    data.user_time = (moment().format('MM/DD/YYYY') + ', ' + new Date().toLocaleTimeString([], { hour12: true }) + ' ' + moment.tz(jstz.determine().name()).zoneAbbr());
    const saveWorkOrder = function (analyticsWorkOrder) {
      if ($scope.action === 'edit') {
        $scope.workOrder.patch(data).then(function () {
          $state.go('work-orders.list');
        });
      } else {
        WorkOrderService.post(data).then(function (result) {
          AnalyticsService.track('Work Order Created', {
            ...AnalyticsService.getWorkOrderGroupProperties(analyticsWorkOrder, AuthDataService.authData),
            work_order_id: result.id,
            context: 'work orders'
          });
          $state.go('work-orders.list');
        });
      }
    };

    // Need to handle the Promise from createWorkOrderObjectForTracking
    if (data.unit) {
      $scope.unitService.get(data.unit).then(function (unitDetails) {
        // Use .then() to handle the Promise
        $scope.createWorkOrderObjectForTracking(data, unitDetails).then(function(analyticsWorkOrder) {
          saveWorkOrder(analyticsWorkOrder);
        });
      });
    } else {
      // Again, use .then() to handle the Promise
      $scope.createWorkOrderObjectForTracking(data, null).then(function(analyticsWorkOrder) {
        saveWorkOrder(analyticsWorkOrder);
      });
    }
  });
};

  $scope.$watch(function () {
    return JSON.stringify($scope.data);
  }, function (newValue, oldValue) {
    if (!angular.equals(newValue, oldValue)) {
      $scope.initExtraFieldsFilters();
    }
  });
};

app.controller('WorkOrderForm', [
  '$scope',
  '$rootScope',
  '$state',
  '$window',
  '$q',
  '$filter',
  '$timeout',
  'workOrderOjb',
  'WorkOrderService',
  'AccountUserService',
  'ngDialog',
  'FormErrorsService',
  'AccountService',
  'AuthDataService',
  'PermissionService',
  'PropertyService',
  'UnitService',
  'AttachmentService',
  'TemplateService',
  'FilterService',
  'NotificationService',
  'WorkOrderCVService',
  'AnalyticsService',
  WorkOrderForm
]);